// extracted by mini-css-extract-plugin
module.exports = {"section":"dedicated-teams_section__yFVmI"};